import React from 'react';

import Image from '../../Commons/Image/Image';
import MICROCENTRO_MAYO from '../../../assets/swiss-medical-center/centro_microcentro.jpg';

import styles from './SwissMedicalMicroCentroMayo.module.scss';

const SwissMedicalMicroCentroMayo = () => {
  return (
    <div className={styles.swiss_medical_micro_centro_mayo}>
      <h3>Microcentro sede 25 de Mayo</h3>
      <p>
        <strong className={styles.swiss_medical_micro_centro_mayo__redText}>Dirección:</strong> 25
        de Mayo 264, Capital Federal
      </p>
      <p>
        <strong className={styles.swiss_medical_micro_centro_mayo__redText}>Turnos:</strong>{' '}
        0810-333-8876
      </p>
      <Image
        src={MICROCENTRO_MAYO}
        alt='Centro medico en 25 de mayo'
        title='Microcentro sede 25 de mayo'
        classes={styles.swiss_medical_micro_centro_mayo__image}
      />
      <p>
        <strong className={styles.swiss_medical_micro_centro_mayo__redText}>
          Atención sin turnos
        </strong>
      </p>
      <p className={styles.swiss_medical_micro_centro_mayo__redText}>
        Lunes a viernes | 8 a 20 hs.
      </p>
      <ul>
        <li>Clínica Médica</li>
        <li>Otorrinolaringología</li>
        <li>Traumatología</li>
      </ul>
    </div>
  );
};

export default SwissMedicalMicroCentroMayo;
